<template>
    <div>
        <BaseListPage
            headline="lang_AZ_DISTRIBUTORS"
            :context="context"
            :alvqa="alvqa"
        >
        <template v-slot:filter>
            <v-col cols="3">
                <DropdownFilter 
                    :context="context + 'VisibilityFilter'"
                    label="lang_AZ_PERSONS_CAPTION_VISIBILITY"
                    :items="visibilityFilterItems"
                    :multiple="true"
                    :clearable="false"
                    :alvqa="alvqa + '-list-dropdown-visibility'"
                />
            </v-col>
        </template>
        <!-- DATA TABLE COMPONENT -->
            <template v-slot:dataTable>
                <BaseDataTableList 
                    :headers="headers"
                    :context="context"
                    readOnlyGhostTdSpan="1"
                    :alvqa="alvqa"
                >
                <!-- TOPSLOT: actions, imports etc. -->
                    <template v-slot:topSlot><AzDistributorsTopSlot /></template>
                <!-- DATA TABLE CONTENT: columns -->
                    <template v-slot:body="{ item }">

                        <ExpandIcon 
                            :isExpanded="item.isExpanded" 
                            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-icon-expand'"
                        />

                        <td>
                            <v-img 
                                v-if="item.item.picture !== undefined && item.item.picture !== null"
                                :src="item.item.picture"
                                :alvqa="alvqa + '-list-row-' + item.item.alvId + '-image'"
                                width="40px"
                            ></v-img>
                            <v-img 
                                v-else
                                :src="require('@/assets/default_picture/default.jpg')"
                                :alvqa="alvqa + '-list-row-' + item.item.alvId + '-image'"
                                width="40px"
                            ></v-img>
                        </td>
                        <td 
                            class="no_ellipsis"
                            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-name'"
                        >
                            {{ item.item.name }}
						</td>
                        <td 
                            class="no_ellipsis"
                            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-city'"
                        >
							{{ item.item.city }}
						</td>
                        <td 
                            class="no_ellipsis"
                            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-country'"
                        >
                            {{ $alvPlugin.getTranslatedCountryName(item.item.country) }}
						</td>
                        <td 
                            class="no_ellipsis"
                            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-alv-id'"
                        >
                            {{ item.item.alvId }}
                        </td>
                    </template>

                    <template v-slot:expandSlot><AzDistributorsReadOnly /></template>

                </BaseDataTableList>
            </template>
        </BaseListPage>
    </div>
</template>

<script>
import BaseListPage from '@/components/_base/BaseListPage'
import BaseDataTableList from '@/components/_base/BaseDataTableList'
import BaseTooltip from '@/components/_base/BaseTooltip'
import ExpandIcon from '@/components/_buttons/ExpandIcon'
import AzDistributorsReadOnly from './_readonly/AzDistributorsReadOnly'
import AzDistributorsTopSlot from './AzDistributorsTopSlot'
import DropdownFilter from '@/components/_filters/DropdownFilter'

export default {
    name: "AzDistributorsList",
    components: {
        BaseListPage,
        BaseDataTableList,
        BaseTooltip,
        ExpandIcon,
        AzDistributorsReadOnly,
        AzDistributorsTopSlot,
        DropdownFilter
    },
    data() {
        return {
            context: "AzDistributors",
            alvqa: "az-distributors"
        }
    },
    computed: {
        visibilityFilterItems() {
            return [
                { text: this.$t('lang_GENERIC_VISIBLE'), value: 'visible', alvqa: this.alvqa + '-list-dropdown-visibility-visible' },
                { text: this.$t('lang_GENERIC_HIDDEN'), value: 'hidden', alvqa: this.alvqa + '-list-dropdown-visibility-hidden' },
                { text: this.$t('lang_GENERIC_CAPTION_MOBILE_APP'), value: 'mobile', alvqa: this.alvqa + '-list-dropdown-visibility-mobile' }
            ]
        },
        headers() {
            return [
                {
					text: '', 
					value: 'data-table-select', 
					align: 'center',
					width: "60px",
                    sortable: false,
					class: 'text-no-wrap'
                },
                { // column 02: Read-only view
                    text: '', 
                    value: 'data-table-expand',
                    align: 'center', 
                    width: "48px",
                    sortable: false,
                    class: 'text-no-wrap'
                },
                {
                    text: '', 
                    value: 'picture', 
                    align: 'center',
                    width: "65px",
                    sortable: false,
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_AZ_DISTRIBUTORS_CAPTION_DISTRIBUTOR'), 
                    value: 'name',
                    align: 'left', 
                    sortable: false, 
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_GENERAL_CAPTION_CITY'), 
                    value: 'city',
                    align: 'left', 
                    sortable: false, 
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_AZ_DISTRIBUTORS_CAPTION_COUNTRY'), 
                    value: 'country',
                    align: 'left', 
                    sortable: false, 
                    class: 'text-no-wrap'
                },  
				{
					text: this.$t('lang_CAPTION_ALVID'),
					value: 'alvId', 
					align: 'left', 
					sortable: false,
					width: "170px",
					class: 'text-no-wrap'
				},
                {
					text: '', 
					value: 'editForm',
					align: 'right',
					sortable: false,
					width: "70px",
					class: 'text-no-wrap'
				}
            ]
        }
    },
    created() {
        this.$store.commit('setSelectedAzDistributorsVisibilityFilter', ['visible', 'hidden'])
    },
    mounted() {
        this.$store.commit('setCountries')
    }
}
</script>